export default function () {
  $('.sitenavbar__search .searchexpandable__search').on('click', function (e) {
    e.preventDefault()
    $('.searchexpandable__search').focus()
    $('.navbar-nav').css('opacity') ? $('.navbar-nav').css('opacity', 0) : $('.navbar-nav').css('opacity', 1) // ToDo: not sure a ternary is robust (requires opacity be exactly 0) or clear (much code repetition).
    toggleSearchOpenClose()
    $('body').on('click', closemastheadsearch)
  })

  /**
   * Allow touch devices to open dropdowns in the main nav
   * First tap is prevented if there is a dropdown.
   * Second consecutive tap on same nav item navigates.
   * ToDo: Fix bug: clicking nav item, then somewhere else on the page, then the same nav item navigates when it should not.
   */
  $('.navbar-nav .main-navigation__navitems.dropdown__link > a').each(function () {
    $(this).on('touchstart', function (event) {
      const toplink = $(this)
      const hreflink = toplink.attr('href')

      // If it's not even a link then return right away
      if (hreflink === '#' || hreflink === '') {
        // Reset any other links
        $('.navbar-nav .main-navigation__navitems.dropdown__link > a').attr('data-clicked', false)
      } else {
        if (toplink.attr('data-clicked') === "true") {
          // Navigate page
          window.location.href = hreflink
        } else if (toplink.closest('li').find('.megadropdown').length || toplink.closest('li').find('.dropdown').length) {
          if (toplink.attr('data-clicked') === "false" || toplink.attr('data-clicked') === undefined) {
            event.preventDefault()
            event.stopPropagation()
            // Reset any other links
            $('.navbar-nav .main-navigation__navitems.dropdown__link > a').attr('data-clicked', false)
            // Remember we clicked this link for next tap/click
            toplink.attr('data-clicked', true)
            // Don't navigate the page
            return false
          }
        }
      }
    })
  })
}

function toggleSearchOpenClose () {
  $('.sitenavbar__nav').toggleClass('searchexpandable-is-open')
}

// set up close event (this close handler destroys itself once used)
function closemastheadsearch (ev) {
  if (!$('.sitenavbar__search').has(ev.target).length) {
    toggleSearchOpenClose()
    $('.navbar-nav').css('opacity', 1)
    $('body').off('click', closemastheadsearch)
  }
}

